module.exports = __webpack_public_path__ + "img/zenit-saint-petersburg.db41d592.png";